/** Настройки анкет, заявок в семью и встречи новичков. */

import type { ReactNode } from 'react';

import { Checkbox, Field, TextInput } from '../../components/ui.tsx';
import { Section, type SettingsTabProps } from './shared.tsx';

export function ApplicationsTab({ draft, update }: SettingsTabProps): ReactNode {
  const ageBroken = draft.familyMinAge > draft.familyMaxAge;

  return (
    <>
      <Section
        title="Заявки в семью"
        description="Что бот проверяет в форме заявки, прежде чем показать её модераторам."
      >
        <div className="grid gap-4 sm:grid-cols-3">
          <Field
            label="Возраст от"
            hint={ageBroken ? 'Больше верхней границы — так сохранить не выйдет' : undefined}
          >
            <TextInput
              type="number"
              min={1}
              max={99}
              value={draft.familyMinAge}
              onChange={(event) => {
                update('familyMinAge', Number.parseInt(event.target.value, 10) || 1);
              }}
            />
          </Field>

          <Field label="Возраст до">
            <TextInput
              type="number"
              min={1}
              max={99}
              value={draft.familyMaxAge}
              onChange={(event) => {
                update('familyMaxAge', Number.parseInt(event.target.value, 10) || 1);
              }}
            />
          </Field>

          <Field label="Шкала адекватности до" hint="Низ шкалы всегда единица">
            <TextInput
              type="number"
              min={2}
              max={10}
              value={draft.familyAdequacyMax}
              onChange={(event) => {
                update('familyAdequacyMax', Number.parseInt(event.target.value, 10) || 2);
              }}
            />
          </Field>
        </div>

        <Field label="Пауза после отказа, дней" hint="0 — без ограничения">
          <TextInput
            type="number"
            min={0}
            max={365}
            value={draft.familyReapplyDays}
            onChange={(event) => {
              update('familyReapplyDays', Number.parseInt(event.target.value, 10) || 0);
            }}
          />
        </Field>

        <label className="flex items-start gap-3">
          <Checkbox
            checked={draft.familyRequireClipLink}
            onChange={(checked) => {
              update('familyRequireClipLink', checked);
            }}
          />
          <span className="text-sm">
            Требовать ссылку в поле «Откаты»
            <span className="block text-xs" style={{ color: 'var(--text-muted)' }}>
              Заявка без ссылки не дойдёт до модераторов: рассматривать в ней нечего
            </span>
          </span>
        </label>
      </Section>

      <Section title="Новые участники" description="Что происходит, когда человек заходит на сервер.">
        <label className="flex items-start gap-3">
          <Checkbox
            checked={draft.welcomeMessageEnabled}
            onChange={(checked) => {
              update('welcomeMessageEnabled', checked);
            }}
          />
          <span className="text-sm">
            Писать приветствие в канал «Добро пожаловать»
            <span className="block text-xs" style={{ color: 'var(--text-muted)' }}>
              Канал задаётся на вкладке «Каналы и роли»
            </span>
          </span>
        </label>

        <label className="flex items-start gap-3">
          <Checkbox
            checked={draft.newcomerRoleEnabled}
            onChange={(checked) => {
              update('newcomerRoleEnabled', checked);
            }}
          />
          <span className="text-sm">
            Выдавать роль новичка
            <span className="block text-xs" style={{ color: 'var(--text-muted)' }}>
              Роль задаётся на вкладке «Каналы и роли»
            </span>
          </span>
        </label>
      </Section>
    </>
  );
}
